import { Badge } from '../../components/badge'
import { defineComponent } from 'vue'
import { villainInfoMap } from './config'
import { Divider } from '../../components/divider'

const toUrl = (s: string) =>
  `https://fortynamo.appspot.com.storage.googleapis.com/${s}`
const gcsFiles = [
  'cdn/mindle-client/contents/villains-by-level/buruk_lv1.png',
  'cdn/mindle-client/contents/villains-by-level/buruk_lv2.png',
  'cdn/mindle-client/contents/villains-by-level/buruk_lv3.png',
  'cdn/mindle-client/contents/villains-by-level/buruk_lv4.png',
  'cdn/mindle-client/contents/villains-by-level/godok_lv1.png',
  'cdn/mindle-client/contents/villains-by-level/godok_lv2.png',
  'cdn/mindle-client/contents/villains-by-level/godok_lv3.png',
  'cdn/mindle-client/contents/villains-by-level/godok_lv4.png',
  'cdn/mindle-client/contents/villains-by-level/kongkong_lv1.png',
  'cdn/mindle-client/contents/villains-by-level/kongkong_lv2.png',
  'cdn/mindle-client/contents/villains-by-level/kongkong_lv3.png',
  'cdn/mindle-client/contents/villains-by-level/kongkong_lv4.png',
  'cdn/mindle-client/contents/villains-by-level/mulung_lv1.png',
  'cdn/mindle-client/contents/villains-by-level/mulung_lv2.png',
  'cdn/mindle-client/contents/villains-by-level/mulung_lv3.png',
  'cdn/mindle-client/contents/villains-by-level/mulung_lv4.png',
  'cdn/mindle-client/contents/villains-by-level/umgyuk_lv1.png',
  'cdn/mindle-client/contents/villains-by-level/umgyuk_lv2.png',
  'cdn/mindle-client/contents/villains-by-level/umgyuk_lv3.png',
  'cdn/mindle-client/contents/villains-by-level/umgyuk_lv4_v2.png',
]

const villainByLevel: Record<string, string[]> = {
  umgyuk: [],
  buruk: [],
  kongkong: [],
  godok: [],
  mulung: [],
}

for (const x of gcsFiles) {
  const [, , , tok3, tok4] = x.split('/')
  if (tok3 === 'villains-by-level') {
    const [, a, d] = tok4.match(/([a-z]+)_lv(\d+)/) || []
    villainByLevel[a as keyof typeof villainByLevel][Number(d) - 1] = toUrl(x)
  }
}

const cautionLightColorMap: Record<string, string> = {
  3: '#F9836033',
  2: '#E7AE5B33',
  1: '#6FA37733',
  0: '#64919F33',
}
const cautionTextColorMap: Record<string, string> = {
  3: '#F98360',
  2: '#E7AE5B',
  1: '#6FA377',
  0: '#64919F',
}

export const CharacterDetail = defineComponent({
  name: 'CharacterDetail',
  props: {
    character: {
      type: String,
      required: true,
    },
    characterKor: {
      type: String,
      required: true,
    },
    percent: {
      type: Number,
      required: true,
    },
    score: {
      type: Number,
      required: true,
    },
    level: {
      type: Number,
      required: true,
    },
    levelKor: {
      type: String,
      required: true,
    },
  },
  setup (props) {
    return () => {
      const { character, score, percent, level, levelKor, characterKor } = props
      const chucheonProps = villainInfoMap[character].props

      return (
        <div>
          {/* 아이콘, 이름, 비율 */}
          <div class="flex items-center">
            <div class="grow">
              <div class="flex items-center">
                <div class="font-bold text-2xl">{characterKor} 지수</div>
                <Badge
                  class="ml-2 text-[0.9375rem] px-3"
                  backgroundColor={cautionLightColorMap[level]}
                  color={cautionTextColorMap[level]}
                >
                  {`${levelKor} ${score.toFixed(1)}점`}
                </Badge>
              </div>
              <div class="text-gray-800 text-sm mt-3">
                검사 인원 중 <b>{levelKor} 수준</b>에 해당하는 <br />
                {characterKor} 비율은 <b>{percent.toFixed(1)}%</b> 입니다
              </div>
            </div>
            <div>
              <div
                class="w-[92px] h-[92px] rounded-full border-2 border-solid p-3 flex items-center justify-center"
                style={{ borderColor: cautionTextColorMap[level] }}
              >
                <img
                  src={villainByLevel[character][level]}
                  class="max-h-full"
                />
              </div>
            </div>
          </div>

          {/* 특징 */}
          <div class="font-bold text-[0.9375rem] mt-6 mb-2">
            {characterKor} 특징
          </div>
          <Divider height="px" color="#dbdbdb" />
          <div class="text-gray-800 font-semibold text-sm leading-6">
            {chucheonProps.map(characterText => (
              <div class="mt-3 first:mt-5 flex items-start">
                <div
                  class="rounded-full w-2 h-2 mr-2 my-2"
                  style={{ backgroundColor: cautionTextColorMap[level] }}
                />
                <div class="grow">{characterText}</div>
              </div>
            ))}
          </div>
        </div>
      )
    }
  },
})
